// utilities/scrollManager.js
let scrollXCache = 0;

export const saveScrollX = (ref) => {
  const scroller = ref?.current?.querySelector(".MuiDataGrid-virtualScroller");
  if (scroller) {
    scrollXCache = scroller.scrollLeft;
  }
};

export const restoreScrollX = (ref) => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      const scroller = ref?.current?.querySelector(
        ".MuiDataGrid-virtualScroller"
      );
      if (scroller) {
        scroller.scrollLeft = scrollXCache;
      }
    }, 0); // allow a tick for MUI to mount
  });
};
